/**
 * Versoes do contrato do Barid (pacote @alfasu-br/barid-contract). O Wazir
 * fala o contrato 1.40: `printerId` dos jobs e o id da impressora VIRTUAL
 * (`barid_printers.id`), repassado ao agente como `payload.virtualId`, e o
 * nack duravel da fila. Agente com contrato anterior continua funcionando
 * (compatibilidade por major), mas a tela avisa para atualizar. A versao que
 * o Wazir anuncia nas chamadas fica em `BARID_API_VERSION` (environments).
 */

/** Menor versao de contrato do agente suportada pelo Wazir. */
export const BARID_MIN_AGENT_API_VERSION = '1.40.0';

function parts(version: string): number[] | null {
  const match = /^\s*v?(\d+)(?:\.(\d+))?(?:\.(\d+))?/.exec(version);
  if (!match) return null;
  return [Number(match[1]), Number(match[2] ?? 0), Number(match[3] ?? 0)];
}

/**
 * Compara duas versoes x.y.z (sufixos como `-beta` sao ignorados).
 * Devolve negativo, zero ou positivo; `null` quando alguma e invalida.
 */
export function compareBaridVersions(a?: string | null, b?: string | null): number | null {
  if (!a || !b) return null;
  const left = parts(a);
  const right = parts(b);
  if (!left || !right) return null;
  for (let i = 0; i < 3; i++) {
    if (left[i] !== right[i]) return left[i] - right[i];
  }
  return 0;
}

/** true quando `available` e mais nova que `installed`. */
export function isBaridUpdateAvailable(installed?: string | null, available?: string | null): boolean {
  const diff = compareBaridVersions(available, installed);
  return diff !== null && diff > 0;
}

/**
 * true quando o agente anuncia um contrato anterior ao minimo suportado.
 * Versao ausente ou ilegivel (agente/API antigos) nao gera aviso.
 */
export function isBaridAgentOutdated(apiVersion?: string | null, minimum = BARID_MIN_AGENT_API_VERSION): boolean {
  const diff = compareBaridVersions(apiVersion, minimum);
  return diff !== null && diff < 0;
}
